import request from '../utils/GraphQLUtil';

function sendPoll(rating, comment) {
  return request({
    url: '',
    method: 'POST',
    data: {
      query: ` mutation registerInquest { registerInquest (input: {value: ${rating}, inquestType: ${process.env.REACT_APP_POLL_ID}, comment: "${comment}", channel: 2}, uuid: "31231" ) {code description} }`
    }
  });
}

// eslint-disable-next-line import/prefer-default-export
export { sendPoll };
